import { useTranslation } from 'react-i18next';
import { FaPlusLightSvgIcon } from '../../../assets/icons/svgs';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { locationIconContainerStyles } from '../styles';

const AddAnotherLocationButtonContent = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        color: colors.textPrimary,
        fontSize: fontSize.md,
      }}
    >
      <div
        style={{
          ...locationIconContainerStyles,
          marginRight: spacing.medium,
        }}
      >
        <FaPlusLightSvgIcon
          size={fontSize['3xl']}
          style={{
            color: colors.textPrimary,
          }}
        />
      </div>
      {t('location.addAnotherLocation')}
    </div>
  );
};

export default AddAnotherLocationButtonContent;
